import Grid from "@mui/material/Grid";
import DataField from "../../atoms/dataField";
import React, { FC, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { CONNECTION_TYPES } from "../../../constants/_pickerValues";
import { IFormField } from "../../shared/globalTypes";

interface Props {
  selectedConnection: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  lndEndpoint: IFormField;
  lndDatabase: IFormField;
  lndUsername: IFormField;
  lndPassword: IFormField;
  lndPort: IFormField;
}

const ConnectionLNDSpoke: FC<Props> = ({
  selectedConnection,
  onChange,
  lndEndpoint,
  lndDatabase,
  lndUsername,
  lndPassword,
  lndPort,
}: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    selectedConnection === CONNECTION_TYPES.lndspoke
      ? setVisible(true)
      : setVisible(false);
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box
        sx={{ border: 1, borderColor: "divider", padding: 3, width: "100%" }}
      >
        <h2>{selectedConnection}</h2>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DataField id="01987870-44e3-48dd-9009-d356c088796a"
              label="Endpoint"
              name="lndEndpoint"
              type="text"
              required={true}
              onChange={onChange}
              value={lndEndpoint.fieldValue}
              error={lndEndpoint.isError}
            />
          </Grid>
          <Grid item xs={6} sx={{ display: "inline-flex" }}>
            <DataField id="e468bb98-8fb5-462e-953f-db6da1def359"
              label="Database"
              name="lndDatabase"
              type="text"
              required={true}
              onChange={onChange}
              value={lndDatabase.fieldValue}
              error={lndDatabase.isError}
            />
          </Grid>
          <Grid item xs={2}>
            <DataField id="958620bb-3841-4632-83bf-ac3a91d8a5f5"
              label="Port"
              name="lndPort"
              type="number"
              required={false}
              onChange={onChange}
              value={lndPort.fieldValue}
              error={lndPort.isError}
            />
          </Grid>
          <Grid item xs={4}>
            <DataField id="88658d1b-597e-402d-a365-36c0a968c0d2"
              label="Username"
              name="lndUsername"
              type="text"
              required={true}
              onChange={onChange}
              value={lndUsername.fieldValue}
              error={lndUsername.isError}
            />
          </Grid>
          <Grid item xs={4}>
            <DataField id="889d6b75-964c-4ddf-999f-8c09813497e1"
              label="Password"
              name="lndPassword"
              required={true}
              type='password'
              onChange={onChange}
              value={lndPassword.fieldValue}
              error={lndPassword.isError}
            />
          </Grid>
        </Grid>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ConnectionLNDSpoke;
